
















































import Worker from '@/components/Worker.vue'
import FormContainer from '../mixins/form-container'
import API from '../services/api'
import Swal from 'sweetalert2'

export default FormContainer.extend({
  components: {
    Worker,
  },

  data: () => ({
    email: '',
    error: false,
  }),

  methods: {
    submit() {
      return API.postRequest('/mail/resetPassword', {
        email: this.email,
      })
        .then((response: any) => {
          if (response.data.ok) {
            this.msExito()
          } else {
            this.msError()
          }
        })
        .catch(() => {
          this.msError()
        })
    },

    async msError() {
      await Swal.fire('Error', 'Puede que el email no este registrado', 'error')
    },

    async msExito() {
      await Swal.fire(
        'Exito',
        'Se envió un link a su correo electrónico para que pueda actualizar su contraseña',
        'success'
      ).then(() => {
        this.$router.push('/home')
      })
    },
  },
})
